export default "__VITE_ASSET__d9c32dec__"